import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const GOOGLE_PROMO_CODE = "2022HINTP7"

export const GoogleGetStartedComponent = (props) => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(GOOGLE_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      GOOGLE_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <div className="col"  dangerouslySetInnerHTML={{__html: props.firstSectionText}}/>
            <img style={{ marginTop: "1rem"}} src={"/images/Google/Google_Nest_Logo.jpg"} alt="Google Nest Logo" className="mb-3" />
            <div className="col"  dangerouslySetInnerHTML={{__html: props.secondSectionText}}/>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-4">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/content/t-mobile/consumer/isp/FAQ.html" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
          <p className="text-center small">Google and Nest Wifi are trademarks of Google LLC</p>
        </div>
      </div>
    </section>
  )
}

